import { render, staticRenderFns } from "./businesscard.vue?vue&type=template&id=c8ecc978&scoped=true&"
import script from "./businesscard.vue?vue&type=script&lang=js&"
export * from "./businesscard.vue?vue&type=script&lang=js&"
import style0 from "./businesscard.vue?vue&type=style&index=0&id=c8ecc978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ecc978",
  null
  
)

export default component.exports